import * as angular from 'angular';
import {IController} from 'angular';
import * as _ from "lodash";

export class RecurringServiceSelectListComponent implements IController {
  options?: any;
  selectedId: any;
  optionIds?: string[];
  ngPlaceholder: any;
  excludeIds?: any;
  accountIds?: string[];
  serviceTypes?: string[];
  scheduleFrequency?: string;
  byWeekDay?: string[];
  noResourceAllocation?: boolean;
  onChange: Function;


  private recurringServicesRef: any;
  private loadLimit: number;
  private infiniteScroll: any;
  private queryString: any;
  private selectedKeys: any;
  public excludedMap: any;

  /* @ngInject */
  constructor(private $recurringServices, private $infiniteScroll, private $log) {
    this.recurringServicesRef = this.$recurringServices();
  }

  $onInit() {
    if (!this.options) {
      this.loadLimit = 20;
      this.recurringServicesRef.$query(this._getQueryPayload());
      this.infiniteScroll = this.$infiniteScroll(this.recurringServicesRef, this.loadLimit, {getFullData: true});
    } else {
      this.loadLimit = 0;
      this.infiniteScroll = this.$infiniteScroll(this.recurringServicesRef, this.loadLimit, {ignoreFetch: true});
      this.infiniteScroll.addItems(this.options);
    }
  }

  $onChanges(changes) {
    if (changes.excludeIds) {
      this.excludedMap = {};
      _.forEach(this.excludeIds, (id) => {
        this.excludedMap[id] = true;
      })
    }
  }

  submitQuery(query) {
    this.queryString = query;
    if (!this.options) {
      this._reload();
    }
  }

  private _reload() {
    this.recurringServicesRef.$query(this._getQueryPayload())
      .then(() => {
        this.infiniteScroll.reload();
      })
      .catch((error) => {
        this.$log.error('Fail to $query', error);
      })
  }

  private _getQueryPayload() {
    return {
      ids: this.optionIds,
      limit:  this.loadLimit,
      query:  this.queryString,
      accountIds: this.accountIds,
      serviceTypes: this.serviceTypes,
      scheduleFrequency: this.scheduleFrequency,
      byWeekDay: this.byWeekDay,
      noResourceAllocation: this.noResourceAllocation
    };
  }
}

angular
  .module('bringoz.admin.deliveries')
  .component('recurringServiceSelectList', {
    bindings: {
      options: '<?',
      optionIds: '<?',
      selectedId: '<',
      ngPlaceholder: '@?',
      excludeIds: '<?',
      accountIds: '<?',
      serviceTypes: '<?',
      scheduleFrequency: '<?',
      byWeekDay: '<?',
      noResourceAllocation: '<?',
      onChange: '&'
    },
    template: require('./recurring-service-select-list.html').default,
    controller: RecurringServiceSelectListComponent
  });
